// @ts-ignore: autogenerated import
import type * as Types from '../../../types/global';

import { gql } from '@apollo/client';
import { SearchResultsFragmentDoc } from './SearchResults.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchQueryVariables = Types.Exact<{
	searchTerm: Types.Scalars['String']['input'];
	count: Types.Scalars['Int']['input'];
	cursor?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;

export type SearchQuery = {
	__typename?: 'Query';
	searchResultArticles?: {
		__typename?: 'ArticlesConnection';
		totalCount: number;
		pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; cursor?: string | null };
		edges: Array<{
			__typename?: 'ArticlesEdge';
			node?: {
				__typename?: 'Article';
				capability: Types.Capability;
				id: string;
				modulesTypes: Array<Types.ModuleType | null>;
				path: string;
				publicationDate?: string | null;
				breakingnewsEnd?: string | null;
				rowId: string;
				teaserText?: string | null;
				title: string;
				image?: {
					__typename?: 'ModuleImage';
					altText?: string | null;
					copyright?: string | null;
					title?: string | null;
					url?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export const SearchDocument = gql`
	query Search($searchTerm: String!, $count: Int!, $cursor: Cursor) {
		searchResultArticles: filterArticles(after: $cursor, first: $count, searchPlain: $searchTerm, sortBy: PUBLICATION_DATE_DESC) {
			...SearchResults
			pageInfo {
				cursor: endCursor
				hasNextPage
			}
			totalCount
		}
	}
	${SearchResultsFragmentDoc}
`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSearchQuery(
	baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> &
		({ variables: SearchQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
}
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
}
export function useSearchSuspenseQuery(
	baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>
) {
	const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
